:host {
    display: block;
    /**
    * @prop --font-family: Font family. Default value --font-klavika-regular.
    * @prop --color-primary: Color primary - used for button color. Default value --color-primary-blue.
    * @prop --color-focus: Color focus - used for focus state. Default value --color-secondary-mustard
    * @prop --color-input-bg: Background color of input fields. Default value --color-tertiary-grey--lighter
    */
}

.selectbox-container {
    position: relative;
    display:inline-flex;
    width:100%;
}

.selectbox-container button {
    border:1px solid transparent;
	background-color:var(--color-primary, rgb(var(--color-primary-blue)));
	cursor:pointer;
	color:white;
	width:50px;
	height:auto;
	position:relative;
	font-size:1.5rem;
}

.selectbox-container button  {
    background: var(--color-primary, rgb(var(--color-primary-blue)));
    color:white;
    aspect-ratio:1/1;
    height:auto;
    width:50px;
    display:flex;
    align-items:center;
    justify-content:center;
}

select:focus {
    outline:none;
    border: solid 1px var(--color-focus, rgb(var(--color-secondary-mustard)));
}

select {
    background-color: var(--color-input-bg, rgb(var(--color-tertiary-grey--lighter)));
    border: 1px solid var(--color-input-bg, rgb(var(--color-tertiary-grey--lighter)));
    border-radius: 0!important;
    color: black;
    display: block;
    overflow: auto;
    width:100%;
    padding: 0.95em 2rem 0.95em 1rem;
    appearance: none;
    font-family: var(--font-family, var(--font-klavika-regular));
    font-size: 1rem;
}